module.exports = __webpack_public_path__ + "img/asbaSaks.2c9b2f30.jpg";